<template>
    <div class="flex flex-col bg-white p-4 rounded">
        <div v-if="$slots.header">
            <slot name="header"></slot>
        </div>
        <div class="flex-1" :class="classes">
            <slot></slot>
        </div>
        <div v-if="$slots.footer">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        classes: {
            type: String,
            required: false
        }
    }
}
</script>
